// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{height:100vh;font-family:PingFangSC-Regular;background:#f1f2f3;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}#app .loadimg{position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;width:13.333vw;height:13.333vw}", ""]);
// Exports
module.exports = exports;
